AppBase.module(
  'Entities',
  function (Entities, App, Backbone, Marionette, $, _) {
    'use strict'

    Entities.AssetAssociationsTree = Backbone.Model.extend({
      initialize: function () {
        if (this.id === undefined) {
          throw new Error('id required')
        }
      },

      defaults: function () {
        return {
          data: [],
          content_tree: [],
          story_tree: [],
        }
      },

      parse: function (response) {
        return {
          data: response.data.map(
            function (dataObject) {
              return {
                children: this.parseIncludedChildren(
                  dataObject,
                  response.included
                ),
                id: dataObject.id,
                images: this.getImagesObject(dataObject),
                link: dataObject.attributes.view_in_opal,
                // @TODO improve this
                // this link_classes value couples this data to the context of being within an asset shroud
                // see app/assets/javascripts/backbone/click_intercept.js.coffee
                link_classes: 'close_layers',
                text: dataObject.attributes.name || dataObject.attributes.title,
              }
            }.bind(this)
          ),
        }
      },

      url: function () {
        return (
          '/moments/' +
          OpalMoments.State.current_brand_slug +
          '/asset_associations/tree.json?asset_reference_id=' +
          this.id
        )
      },

      getImagesObject: function (dataObject) {
        // making the assumption that OpalMoments.State.all_stories_fetched = true
        if (dataObject.type === 'stories') {
          return {
            icon: 'story',
            sprite: 'moments',
            type: 'glyph',
            fill: '#' + dataObject.attributes.color,
          }
        }

        if (dataObject.type === 'moments') {
          return { icon: 'moment', sprite: 'moments', type: 'glyph' }
        }

        if (dataObject.type === 'posts') {
          return {
            classes:
              'service_icon small type_' +
              dataObject.attributes.service_name.toLowerCase(),
            type: 'custom',
          }
        }
      },

      parseContentTree: function () {
        var contentTree = this.get('data').filter(function (treeNode) {
          return treeNode.children.length > 0
        })
        this.set({ content_tree: contentTree })
      },

      parseIncludedChildren: function (dataObject, included) {
        if (_.isEmpty(dataObject.relationships)) {
          return []
        }

        return [].concat.apply(
          [],
          Object.keys(dataObject.relationships).map(
            function (key) {
              return dataObject.relationships[key].map(
                function (relationship) {
                  var childDataObject = _.findWhere(included, {
                    id: relationship.id,
                    type: key,
                  })

                  return {
                    children: this.parseIncludedChildren(
                      childDataObject,
                      included
                    ),
                    images: this.getImagesObject(childDataObject),
                    text:
                      childDataObject.attributes.name ||
                      childDataObject.attributes.title,
                    link: childDataObject.attributes.view_in_opal,
                    // @TODO improve this
                    // this link_classes value couples this data to the context of being within an asset shroud
                    // see app/assets/javascripts/backbone/click_intercept.js.coffee
                    link_classes: 'close_layers',
                  }
                }.bind(this)
              )
            }.bind(this)
          )
        )
      },

      parseStoryTree: function () {
        var storyTree = this.get('data')
          // filter out "no story" story
          .filter(function (treeNode) {
            return treeNode.id > 0
          })
          .map(function (treeNode) {
            return _.extend({}, treeNode, {
              children: [],
            })
          })
        this.set({ story_tree: storyTree })
      },
    })
  }
)
